import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { _baseUrl } from '../../helper/global-helper';

@Injectable({
    providedIn: 'root',
})
export class ReleaseRetrievalService {
    baseUrl: string;

    constructor(private http: HttpClient) {
        this.baseUrl = _baseUrl;
    }

    public getReleaseNotes(line: string) {
        return this.http.get(this.baseUrl + 'releases?type=releases&productline=' + line + 'line', {
            observe: 'response',
            responseType: 'json',
        });
    }

    public getComponentNotes(component: string) {
        return this.http.get(this.baseUrl + 'releases?type=component&component=' + component, {
            observe: 'response',
            responseType: 'json',
        });
    }

    public getComponentList() {
        return this.http.get(this.baseUrl + 'releases?type=componentlist', {
            observe: 'response',
            responseType: 'json',
        });
    }

    public downloadAllNotes(line: string) {
        return this.http.get(this.baseUrl + 'releases?type=export&releasetoexport=all&productline=' + line + 'line', {
            observe: 'response',
            responseType: 'blob',
        });
    }
}

export type ReleaseNotes = {
    metadata: {
        info: string;
        type: string;
        version: string;
        hasMd5: boolean;
    };
    releaseName: string;
    description: string;
    info: {
        author: string;
        datetime: string;
        labels: string[];
    };
    componentVersions: [
        {
            componentName: string;
            versionTag: string[];
            changed: boolean;
            external: boolean;
        }
    ];
};

export type ComponentNotes = {
    metadata: {
        info: string;
        type: string;
        version: string;
        hasMd5: boolean;
    };
    info: {
        labels: string[];
    };
    componentName: string;
    description: string;
    versions: [
        {
            versionTag: string;
            versionName: string;
            versionDescription: string;
            subVersions?: [
                {
                    subVersionName: string;
                    subVersionTag: string;
                }
            ];
            versionNotes: {
                features: string[];
                bugfixes: string[];
                improvements: string[];
            };
            versionInfo: {
                author: string;
                datetime: string;
                labels: string[];
            };
        }
    ];
};

export type Components = {
    metadata: {
        info: string;
        type: string;
        version: string;
    };
    components: [
        {
            componentName: string;
            componentFile?: string;
            type: string;
        }
    ]
}

export type ComponentPart = {
    componentName: string;
    componentFile?: string;
    type: string;
    component?: ComponentNotes;
    loaded?: boolean;
    error?: boolean;
}
